require('./affix');
require('./ui-bootstrap-custom-1.3.2');
require('./ui-bootstrap-custom-tpls-1.3.2');


// WEBPACK FOOTER //
// ./../Hyundai.Web.Shared/vendor/bootstrap/index.js